export default __webpack_public_path__ + "static/media/logo404.ce6e089d.svg";